const soundCache = new Map<string, HTMLAudioElement>();

const playSound = (sound: string, volume = 100) => {
  let audio: HTMLAudioElement;
  if (volume === 0) return;
  if (soundCache.has(sound)) {
    audio = soundCache.get(sound);
  } else {
    audio = new Audio(sound);
    soundCache.set(sound, audio);
  }
  audio.volume = volume / 100;
  audio.play();
};

export default playSound;
